const BASE_URL = import.meta.env.VITE_API_URL || '/api'

/**
 * Public, unauthenticated views of what is happening on the platform. These
 * back the signed-out dashboard, which used to render hard-coded numbers.
 *
 * Every counter is a live count, so a quiet week shows a quiet number. Callers
 * should render what comes back rather than hiding small values.
 */
export interface PlatformStats {
  leagues: number
  clubs: number
  universities: number
  live_seasons: number
  /** Distinct users holding an active roster spot — not registered accounts. */
  players: number
  matches_played: number
}

export interface ResultTeam {
  team_id: string
  name: string
  logo_url?: string
  score: number
  /** "home" | "away"; empty in free-for-all formats. */
  designation?: string
  /** Both sides are false on a draw. */
  won: boolean
}

export interface PlatformResult {
  match_id: string
  game_name: string
  game_slug: string
  organization_name: string
  organization_slug: string
  organization_type: string
  best_of: number
  played_at: string
  teams: ResultTeam[]
}

export async function getPlatformStats(): Promise<PlatformStats> {
  const res = await fetch(`${BASE_URL}/platform/stats`)
  if (!res.ok) throw new Error('Failed to fetch platform stats')
  return res.json()
}

export async function listPlatformResults(limit = 6): Promise<PlatformResult[]> {
  const res = await fetch(`${BASE_URL}/platform/results?limit=${limit}`)
  if (!res.ok) throw new Error('Failed to fetch results')
  return res.json()
}
